export const CREATE_TASK = "api/task/"
export const UPDATE_TASK = "api/task/id/{id}"
export const GET_TASKS_BY_PROJECT = "api/task/project_id/{projectId}"
export const GET_TASKS_BY_ALL_USER_PROJECTS = "api/task/all_user_projects/{email}"
export const GET_TASKS_BY_USER = "api/task/assigned_to/{email}"
export const GET_TASK_BY_ID = "api/task/id/{id}"
export const DELETE_TASK = "api/task/id/{id}"
export const GET_TASK_LIST = "api/task/"
export const POST_ASSIGNED_TASKS = "api/task/assigned_tasks"
export const MARK_TASK_AS_COMPLETED = "api/task/mark_as_closed/{id}"
export const PING_TASK = "api/task/ping/{id}"
export const CLOSE_PING_TASK = "api/task/close_ping/{id}"
